<template>
  <div class="home">
    <a-row :gutter="[16, 16]">
      <a-col :lg="12" :md="24" :sm="24" :xl="14" :xs="24" :xxl="18">
        <a-card>
          <a-input v-model="searchPhrase" placeholder="Szukaj" @change="handleInput(searchPhrase)">
            <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="search"/>
          </a-input>
        </a-card>
      </a-col>
      <a-col :lg="12" :md="24" :sm="24" :xl="10" :xs="24" :xxl="6">
        <a-card>
          <a-button block icon="plus" type="primary" @click="goTo({name: 'Form'})">
            Dodaj użytkownika
          </a-button>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="[16, 16]">
      <a-col :span="24">
        <a-card :bodyStyle="{ padding: 0 }">
          <a-table :columns="columns" :data-source="users" :expandRowByClick="true" :loading="loadingUsersList"
                   :pagination="pagination"
                   rowKey="accountUuid" size="middle"
                   style="border-radius: 16px; overflow: hidden"
                   @change="handlePaginationChange">
            <span slot="status" slot-scope="record">
              <a-badge :status="record !== undefined ? statusDictionary[record.accountStatus] : 'default'"/>
            </span>
            <div slot="name" slot-scope="record">{{
                record.accountType !== 'COMMERCIAL' ? `${record.name} ${record.surname}`
                    : record.name
              }}
            </div>
            <div slot="personIdNip" slot-scope="record">
              <a-tooltip v-if="record.personIdValidation && record.accountType !== 'COMMERCIAL'">
                <template slot="title">
                  {{ personIdVerificationDictionary[record.personIdValidation.result].text ? personIdVerificationDictionary[record.personIdValidation.result].text : 'Brak danych' }}
                </template>
                <a-icon
                    :type="personIdVerificationDictionary[record.personIdValidation.result].icon"
                    theme="twoTone"
                    :two-tone-color="personIdVerificationDictionary[record.personIdValidation.result].color"/>
              </a-tooltip>
              {{
                (record.accountType !== 'COMMERCIAL' ? record.personId :
                    `${record.nip ? `NIP: ${record.nip}` : '-'}`).toUpperCase()
              }}
            </div>
            <div slot="dorm" slot-scope="record">
              {{ record.dorm.name }}
            </div>
            <div slot="created" slot-scope="record">
              {{ new Date(record.created) | moment('HH:mm - DD.MM.YYYY') }} r.
            </div>
            <div slot="expandedRowRender" slot-scope="record">
              <div class="table-details">
                <div v-if="record.homeAddress" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Adres zameldowania</small><br/>
                  {{ record.homeAddress }}
                </div>
                <div v-if="record.emailAddress" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Adres e-mail</small><br/>
                  {{ record.emailAddress }}
                </div>
                <div style="margin-bottom: 0.5em; text-align: right;">
                  <a-button icon="user" type="primary"
                            @click="goTo({ name: 'User', params: { uuid: record.accountUuid } })">
                    Pokaż profil
                  </a-button>
                </div>
              </div>
            </div>
          </a-table>
        </a-card>
      </a-col>
    </a-row>

    <a-row :gutter="[16, 16]">
      <a-col :span="24">
        <a-card>
          <a-badge class="legend-item" status="success" text="Aktywny"/>
          <a-badge class="legend-item" status="processing" text="Gotowy do aktywacji"/>
          <a-badge class="legend-item" status="warning" text="Weryfikacja dokumentu"/>
          <a-badge class="legend-item" status="error" text="Zablokowany"/>
          <a-badge class="legend-item" status="default" text="Nieaktywny/Wygasły"/>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>


<script>
import httpClient from "../utils/httpClient";

const columns = [
  {
    title: '',
    key: 'status',
    scopedSlots: {customRender: 'status'},
  },
  {title: 'Imię i nazwisko', key: 'name', scopedSlots: {customRender: 'name'}},
  {title: 'PESEL/Paszport', key: 'personId', scopedSlots: {customRender: 'personIdNip'}},
  {title: 'Lokalizacja', key: 'dorm', scopedSlots: {customRender: 'dorm'}},
  {title: 'Pomieszczenie', dataIndex: 'room', key: 'room'},
  {title: 'Państwo', dataIndex: 'country', key: 'country'},
  {title: 'Data utworzenia', key: 'created', scopedSlots: {customRender: 'created'}},
  {
    title: '',
    key: 'operation',
    scopedSlots: {customRender: 'action'},
  },
];

const statusDictionary = {
  "INACTIVE": "default",
  "WAITING": "warning",
  "DOCUMENT_APPROVED": "processing",
  "ACTIVE": "success",
  "BANNED": "error",
  "DEPRECATED": "default",
}

const personIdVerificationDictionary = {
  "VALID_PESEL": {
    "color": "#52c41a",
    "text": "Numer PESEL poprawny",
    "icon": "check-circle",
  },
  "VALID_PASSPORT": {
    "color": "#52c41a",
    "text": "Numer paszportu poprawny",
    "icon": "check-circle",
  },
  "INVALID_PESEL_FORMAT": {
    "color": "#faad14",
    "text": "Niepoprawny format numeru PESEL",
    "icon": "warning",
  },
  "INVALID_PASSPORT_FORMAT": {
    "color": "#faad14",
    "text": "Niepoprawny format numeru paszportu",
    "icon": "warning",
  },
  "INVALID_PESEL_DATE": {
    "color": "#f5222d",
    "text": "Niepoprawna data urodzenia",
    "icon": "exclamation-circle",
  },
  "INVALID_PESEL_CHECKSUM": {
    "color": "#f5222d",
    "text": "Niepoprawna suma kontrolna numeru PESEL",
    "icon": "exclamation-circle",
  },
  "INVALID_FORMAT": {
    "color": "#faad14",
    "text": "Niepoprawny format",
    "icon": "warning",
  }
}

export default {
  name: "Users",
  data() {
    return {
      columns,
      statusDictionary,
      personIdVerificationDictionary,
      loadingUsersList: true,
      searchPhrase: "",
      debounce: null,
      users: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 1,
        defaultPageSize: 20,
      },
    };
  },
  mounted() {
    this.getUsers()
    this.$emit("loadedView");
  },
  methods: {
    handleInput() {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(this.getUsers, 300);
    },

    getUsers() {
      this.loadingUsersList = true;
      httpClient
          .post(`/admin/accounts?size=${this.pagination.pageSize}&page=${this.pagination.current}`, {
            filter: this.searchPhrase,
          })
          .then((response) => {
            this.pagination = response.page;
            this.users = response.payload;
          }).finally(() => {
        this.loadingUsersList = false;
      });
    },

    handlePaginationChange(pagination) {
      const {current, pageSize} = pagination;
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getUsers()
    },

    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },
  },
};
</script>

<style scoped>
.table-details {
  background-color: rgba(200, 200, 200, 0.1);
  padding: 0.5em 1em;
  margin-right: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.legend-item {
  margin-left: 1.4em;

}
</style>
